import React from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';
import './HomeTabContentView.css';
import { homeTabContentviewStyle } from './styles/styles';

export const HomeTabContentView = (props) => {
  const { activeKey, onChange, tabContents } = props;
  return (
    <div style={homeTabContentviewStyle}>
      <Tabs
        onChange={onChange}
        activeKey={activeKey}
        type="card"
        items={tabContents}
        style={{ paddingRight: '15px' }}
      />
    </div>
  );
};

HomeTabContentView.propTypes = {
  activeKey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  tabContents: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      children: PropTypes.node,
      disabled: PropTypes.bool,
    }),
  ).isRequired,
};
HomeTabContentView.defaultProps = {
  activeKey: '',
  onChange: () => null,
  tabContents: null,
};
